import { Component, Input, OnDestroy } from '@angular/core';

import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

import { DistributionModel } from '../../../models/distribution.model';
import { DistributionService } from '../../../../../Common/TargetingShared/services/distribution.service';
import { ButtonTypesEnum } from '../../../../../Common/Forms/enums/button-types.enum';
import { CoreDialogService } from '../../../../../Core/Dialogs/services/dialog.service';
import { DistributionStatus } from '../../../../../Common/TargetingShared/enum/distribution-status.enum';
import { DistributionRecipientStatus } from '../../../enums/distribution-recipient-status.enum';

@Component({
    selector: 'agpr-recipient-panel',
    templateUrl: './recipient-panel.component.html',
    styleUrls: ['./recipient-panel.component.scss'],
    standalone: false
})
export class RecipientPanelComponent implements OnDestroy {
    @Input() isToggleable: boolean = true;
    @Input() canEditRecipient: boolean = true;
    @Input() error: string = '';
    @Input() overlayContainer: Element;
    @Input() showHeader: boolean = true;
    @Input() showExtraPadding: boolean = true;

    id: string = 'agpr_recipient_panel';

    distribution: DistributionModel;

    readonly buttonTypes = ButtonTypesEnum;
    readonly distributionStatus = DistributionStatus;
    readonly recipientStatus = DistributionRecipientStatus;

    private subscriptions: Subscription[] = [];

    constructor(
        public coreDialogService: CoreDialogService,
        public distributionService: DistributionService,
    ) {
        this.subscriptions.push(
            this.distributionService.getFocusedResource().pipe(filter(x => !!x)).subscribe(distribution => {
                this.distribution = distribution;
            })
        );
    }

    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
}
